// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"6aeb3b5c","453":"27d41ac9","543":"247b3aec"}[chunkId] + ".chunk.js";
};